import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
  removeLocalStorageLogout,
} from '@/auth/utils'
import store from '@/store'
import useJwt from '@/@core/auth/jwt/useJwt'
import pages from './routes/pages'
import wishlist from './routes/komship/hiring/wishlist'

// komship
import dashboardKompship from './routes/komship/dashboard/index'
import produk from './routes/komship/produk/index'
import order from './routes/komship/order/index'
import pickup from './routes/komship/pickup/index'
import customer from './routes/komship/customer/index'
import settingKompship from './routes/komship/setting-kompship/index'
import keuangan from './routes/komship/keuangan/index'
import hiring from './routes/komship/hiring/index'
import opsional from './routes/komship/opsional/index'
import myapps from './routes/komship/myapps/index'
import ticketing from './routes/komship/ticketing/index'
import warehouse from './routes/komship/warehouse/index'
import inbox from './routes/komship/inbox'
import komcard from './routes/komcards'
import voucher from './routes/voucher'
import komads from './routes/komads'
import team from './routes/team'
import komed from './routes/komed'

// kompack
import gudang from './routes/kompack/gudang/index'
import partner from './routes/kompack/partner/index'

// komtim
import komtim from './routes/komtim/komtim'

// komstore
import komstore from './routes/komstore/index'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...pages,

    ...dashboardKompship,
    ...inbox,
    ...order,
    ...pickup,
    ...produk,
    ...customer,
    ...settingKompship,
    ...keuangan,
    ...hiring,
    ...opsional,
    ...myapps,
    ...ticketing,
    ...warehouse,
    ...wishlist,
    ...gudang,
    ...komtim,
    ...komcard,
    ...voucher,
    ...komads,
    ...team,
    ...partner,
    ...komed,
    ...komstore,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const approvalKyc = to.matched.some(record => record.path === '/verification-ktp')

  const isLoggedIn = isUserLoggedIn()

  if (approvalKyc) {
    try {
      const status = await store.dispatch('komcards/getKycStatus')

      if (status === 'approved') {
        next('/')
      } else {
        next()
      }
    } catch (err) {
      next('/')
    }
  }

  if (to.name === 'kompship-daftar') {
    window.location.href = 'https://komship.id/pendaftaran'
  }

  // if (approvalKyc && user.verification_ktp_status === 2) {
  //   return next('/')
  // }

  if (to.name === 'unauthenticated' || to.name === 'error-404') {
    return next()
  }

  if (to.name === 'success-verification-email') {
    removeLocalStorageLogout()
    return next()
  }

  if (
    !canNavigate(to)
    && !isLoggedIn
    && to.name !== 'success-verification-email'
  ) {
    // Redirect to login if not logged in
    return next({ name: 'auth-login' })
  }

  const user = getUserData()
  if (isLoggedIn && user.role_id === 4) {
    // if user is logged in and is kompack
    if (user.is_kompack) {
      const kompackOnboarding = 'kompack-partner-onboarding'
      // if has not been onboarded yet → redirect to onboarding
      if (!user.is_onboarding_kompack) {
        if (to.name !== kompackOnboarding) return next({ name: kompackOnboarding })
        return next()
      }
      // if has been onboarded → redirect to gudangku
      if (user.is_onboarding_kompack && (to.name === kompackOnboarding || to.name === 'auth-login')) {
        return next({ name: 'gudangku' })
      }
    }

    // if user is logged in and is komtim
    if (user.is_komtim) {
      const komtimOnboarding = 'komtim-partner-onboarding'
      // if has not been onboarded yet → redirect to onboarding
      if (!user.is_onboarding_komtim) {
        if (to.name !== komtimOnboarding) return next({ name: komtimOnboarding })
        return next()
      }
      // if has not been onboarded yet → redirect to talent
      if (user.is_onboarding_komtim && (to.name === komtimOnboarding || to.name === 'auth-login')) {
        return next({ name: 'talent' })
      }
      return next()
    }

    // if user is logged in and is komstore
    if (user.is_komstore === 1) {
      if (!user.is_onboarding_komstore) {
        const isOnlineStorePath = to.path.includes('/komstore') || to.path.includes('/online-store')
        if (isOnlineStorePath && to.name !== 'online-store-onboarding') return next({ name: 'online-store-onboarding' })
        if (!isOnlineStorePath && to.name === 'online-store-onboarding') return next({ name: 'dashboard-analytics' })
      } else if (to.name === 'online-store-onboarding') {
        return next({ name: 'online-store-management' })
      }
    }

    if (to.name === 'auth-login') return next(from.path)
    return next()
  }

  // Redirect if logged in
  if (
    // eslint-disable-next-line operator-linebreak
    (to.meta.redirectIfLoggedIn && isLoggedIn) ||
    (!canNavigate(to) && isLoggedIn)
  ) {
    const userData = getUserData()
    const isKomship = getUserData()

    if (to.name !== 'auth-login') {
      return next({ name: 'error-404' })
    }

    next(
      getHomeRouteForLoggedInUser(
        // eslint-disable-next-line comma-dangle
        userData ? userData.role_name.toUpperCase() : null,
        isKomship ? userData.is_komship : null,
        // eslint-disable-next-line comma-dangle
      )
    )
  }

  return next()
})

router.afterEach(to => {
  const loginPaths = ['/login', '/reset-newpassword']
  document.title = loginPaths.includes(to.path) ? 'Login Partner Komerce' : 'Komerce.id'
})

export default router
